import { render, staticRenderFns } from "./DataListStaffs_validate.vue?vue&type=template&id=36d83852&scoped=true&"
import script from "./DataListStaffs_validate.vue?vue&type=script&lang=js&"
export * from "./DataListStaffs_validate.vue?vue&type=script&lang=js&"
import style0 from "./DataListStaffs_validate.vue?vue&type=style&index=0&id=36d83852&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d83852",
  null
  
)

export default component.exports